import { merchantImageWithMerchantToken, merchantWithMerchantToken } from '@lib/api/v2';

/**
 * 현재 지점의 키오스크 버전
 * @returns
 */
export const getMerchantKioskVersion = () => merchantWithMerchantToken.get('/kiosk/version');

/**
 * 앱에서 사용하는 지점 정보 조회
 * @returns
 */
export const getMerchantAppInfo = () => merchantWithMerchantToken.get('/app/info');

export const getMerchantOpsBriefing = (date?: string, includeAnalytics = true) =>
  merchantWithMerchantToken.get('/ops-briefing', {
    params: {
      ...(date ? { date } : {}),
      includeAnalytics,
    },
  });

export const postMerchantImg = (form: FormData) =>
  merchantImageWithMerchantToken.post('/img', form);
export const deleteMerchantImg = (imgId: string) =>
  merchantWithMerchantToken.delete(`/img/${imgId}`);

export const patchMerchantTag = (createTag: string[], deleteTagId: number[]) =>
  merchantWithMerchantToken.patch('/tag', {
    createTag,
    deleteTagId,
  });

export const getMerchantReview = (
  page: number,
  startDate: string,
  endDate: string,
  phoneNum?: string,
  limit?: number,
) =>
  merchantWithMerchantToken.get('/review', {
    params: {
      page,
      startDate,
      endDate,
      phoneNum,
      limit,
    },
  });

export const getMerchantReviewDetail = (ticketReviewId: string) =>
  merchantWithMerchantToken.get(`/review/${ticketReviewId}`);

export const patchMerchantReviewReply = (ticketReviewId: string, content: string) =>
  merchantWithMerchantToken.patch(`/review/reply`, {
    ticketReviewId,
    content,
  });

/**지점 서비스 정보 조회 */
export const getMerchantService = () => merchantWithMerchantToken.get('/app/service');

/**지점 서비스 정보 조회 */
export const createMerchantService = (data: { serviceCategory: number; tagName: string }[]) =>
  merchantWithMerchantToken.post('/app/service', { data });

/**지점 서비스 삭제  */
export const deletMerchnatService = (tagCategoryId: string, tagId?: string) =>
  merchantWithMerchantToken.delete(`/app/service`, {
    params: {
      tagCategoryId,
      tagId,
    },
  });

/**백오피스에 등록한 서비스 태그 정보 출력 */
export const getMerchantServiceCategory = () =>
  merchantWithMerchantToken.get('/app/service/category');

/**
 * 키오스크 옵션 정보 조회
 * @returns
 */
export const getKioskOptionInfo = () => merchantWithMerchantToken.get('/kiosk/option/info');
